module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-316.5b4cf45.woff2";